import { nrkChevronRight } from '@nrk/core-icons'
import { html } from '../../../lib/html'
import { renderResponsiveImage } from '../responsive-image'
import { stillingUrl } from '../../../navigation'
import { toSlug } from '../../../lib/emneknagg'
import styles from './stillingkort.module.css'

export function byRelevance(sok) {
  const sokSlugs = sok?.valgteEmneknagger?.map(toSlug) ?? []
  const numberOfRelevantEmneknagg = (image) => {
    const { emneknagger = [] } = image
    return emneknagger.map(toSlug).filter((slug) => sokSlugs.includes(slug)).length
  }

  return (a, b) => {
    return numberOfRelevantEmneknagg(b) - numberOfRelevantEmneknagg(a)
  }
}

export function renderStillingkort(stilling, index, sok, baseUrl, lazy) {
  const tempBilder = [...(stilling.bilder ?? [])]
  const bilde = tempBilder.sort(byRelevance(sok))[0]

  return html`<div class="${styles.stilling}" style="--stilling-index: ${index};">
    <a href="${stillingUrl(baseUrl, stilling.slug, sok.valgteEmneknagger)}">
      <div class="${styles.stilling__content}">
        <h3>${stilling.navn}</h3>
        ${nrkChevronRight}
      </div>
      ${renderResponsiveImage(bilde, '(min-width: 758px) 350px, calc(100vw - 28px)', lazy)}
    </a>
  </div>`
}
